import { LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT_SUCCESS, LOGOUT_ERROR, UPDATE_USER } from "../../constants/Login";

export function loginSuccess(user) {
    return {
        type: LOGIN_SUCCESS,
        payload: {user}
    };
};

export function loginError(error) {
    return {
        type: LOGIN_ERROR,
        payload: {error}
    };
};

export function logoutSuccess() {
    return {
        type: LOGOUT_SUCCESS
    };
};

export function logoutError(error) {
    return {
        type: LOGOUT_ERROR,
        payload: {error}
    };
};

export function updateUser(user) {
    return {
        type: UPDATE_USER,
        payload: {user}
    };
};